import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { getPayload, loadingStatus } from "actions"
import Title from "../general/title"
import _ from "lodash"
import * as Yup from "yup"
import FullTable from "components/FullTable"
import currentUser from "helpers/currentUser"
import fields from "models/section"
import { Link } from "react-router-dom"
import moment from "moment-timezone"
import helpers from "helpers/helpers"

class ARC extends Component {
	constructor(props) {
		super(props)
		this.state = {
			user: currentUser(),
			fields: fields,
			approvedColumns: [
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Commuity",
					accessor: "community",
				},
				{
					Header: "Sq Ft",
					accessor: "sqft",
				},
				{
					Header: "Stories",
					accessor: "stories",
				},
				{
					Header: "Beds",
					accessor: "beds",
				},
				{
					Header: "Full Baths",
					accessor: "full_baths",
				},
				{
					Header: "Half Baths",
					accessor: "half_baths",
				},
				{
					Header: "Garage",
					accessor: "garage",
				},
				{
					Header: "View",
					accessor: "edit",
				},
			],
			pendingColumns: [
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Submission Date",
					accessor: "submission_date",
					filterMethod: (f, r) => helpers.tableText(f, r, "submission_date"),
				},
				{
					Header: "Status",
					accessor: "status",
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "View",
					accessor: "edit",
				},
			],
		}
	}

	componentDidMount() {}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			legal_name: Yup.string().notRequired(),
			property: Yup.number().required("Required"),
			platted_lots: Yup.number().required("Required"),
			isd: Yup.number().required("Required"),
			//acreage: Yup.number().required("Required"),
			developers: Yup.array().min(1, "Please choose at least one developer.").notRequired(),
			//neighborhood: Yup.number().required("Required"),
			default_developer: Yup.number().notRequired(),
			subdivision: Yup.number().required("Required"),
			substantially_complete: Yup.number().required("Required"),
			completion: Yup.number().required("Required"),
			sqft_min: Yup.number().notRequired(),
			sqft_max: Yup.number().notRequired(),
		})
	}

	options = (f, name) => {
		let ret = []
		this.props.payload.public[name].forEach((v) => {
			if (f.values.property && f.values.property == v.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	buildProperties = () => {
		let ret = []
		let user = currentUser()
		_.forEach(this.props.payload.public.properties, (v) => {
			if (user.activeProperties.includes(v.id)) {
				ret.push({ label: v.name, value: v.id })
			}
		})
		return ret
	}

	buildPendingTable = () => {
		let user = currentUser()
		let ret = []
		let path = this.props.payload.salespersonPayload.arc?.floorplans
		if (user.group == 14) {
			path = this.props.payload.arcPayload.arc.floorplans
		}

		_.forEach(path, (v) => {
			let url = `/entry/arc/edit/${v.id}`
			if (user.group == 14) {
				url = `/arc/edit/${v.id}`
			}
			let add = false
			let property
			let underReview = true
			let master = false // this is a tracker for if the master plan is rejected or if it's an elevation
			//? First check if general master plan is rejected/under review
			if (v.arc_approved && typeof v.arc_approved == "object") {
				_.forEach(v.arc_approved, (r) => {
					if (r.approved === false && r.property === this.props.activeProperties[0]) {
						if (v.id === 509) {
							console.log(r)
						}
						property = _.find(this.props.payload.public.properties, { id: r.property })
						// If no rejection, then under review
						if (this.props.activeProperties.includes(r.property) && r.rejected) underReview = false
						add = true
						master = true
						return
					}
				})
			}
			//? now check for elevations on this plan that are under review.  doesn't check master plan approval
			if (!add) {
				let elevations = _.filter(this.props.payload.public.elevations, {
					floorplan: v.id,
					property: this.props.activeProperties[0],
				})
				_.forEach(elevations, (e) => {
					// if an elevation is under review or rejected, add this to the list
					if (e.approval_status === null || e.approval_status === 0) {
						property = _.find(this.props.payload.public.properties, { id: e.property })
						add = true
						if (e.approval_status === 0) underReview = false
						return
					}
				})
			}
			if (add) {
				let text = master ? "Master Plan" : "Elevation"
				ret.push({
					property: property.name || "",
					name: v.name,
					submission_date: v.addedDate ? moment.unix(v.addedDate).format("MM/DD/YY") : "",
					status: underReview ? `Under Review - ${text}` : `Rejected - ${text}`,
					edit: (
						<Link to={url}>
							<i className="far fa-edit"></i>
						</Link>
					),
				})
			}
		})
		return ret
	}

	buildApprovedTable = () => {
		let user = currentUser()
		let ret = []
		_.forEach(this.props.payload.public.floorplans, (v) => {
			if (Array.isArray(user.builders) && !user.builders.includes(v.builder)) return
			let props = _.intersection(user.activeProperties, v.properties)
			if (props.length > 0 && v.arc_approved && v.arc_approved.length > 0) {
				let approved = _.filter(v.arc_approved, (r) => r.approved)
				let comName = ""
				// multiple properties, so go through and make a string of the community names
				if (approved.length > 1) {
					{
						_.forEach(approved, (r) => {
							let com = _.find(this.props.payload.public.properties, { id: r.property })
							if (com) {
								comName += com.name + ", "
							}
						})
					}
				}
				_.forEach(approved, (r, k) => {
					// if this is the last property, then add it to the table
					if (approved.length == 1) {
						let com = _.find(this.props.payload.public.properties, { id: r.property })
						if (com) {
							comName = com.name
						}
					}
					if (k == approved.length - 1) {
						let url = `/entry/arc/edit/${v.id}`
						if (user.group == 14) {
							url = `/arc/edit/${v.id}`
						}
						comName = _.trim(comName, ", ")
						ret.push({
							name: v.name,
							community: comName,
							sqft: v.sqft,
							beds: v.beds,
							full_baths: v.full_baths,
							half_baths: v.half_baths,
							garage: v.garage,
							stories: v.stories,
							edit: (
								<Link to={url}>
									<i className="far fa-edit"></i>
								</Link>
							),
						})
					}
				})
			}
		})
		return ret
	}

	getTrProps = (state, rowInfo, instance) => {
		if (rowInfo) {
			let v = rowInfo.original
			let className = ""
			if (v.status == "Under Review") {
				className = "statusColor--pending"
			} else if (typeof v.status === "string" && v.status.includes("Rejected")) {
				className = "statusColor--rejected"
			}

			return {
				className: className,
			}
		}
		return {}
	}

	render() {
		let user = currentUser()
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="entryDashboard">
					<div className="imageGroup">
						<Title title="ARC Portal" showDate={false} />
						<div className="content">
							<ul className="horizontalNav">
								<li>
									<Link to={user.group == 13 ? "/entry/arc/new" : "/arc/new"}>
										Submit New Master Plan
									</Link>
								</li>
							</ul>
							<h2>Submissions</h2>
							<FullTable
								data={this.buildPendingTable()}
								columns={this.state.pendingColumns}
								name="arc__pending__lots"
								title="ARC Pending Lots"
								getTrProps={this.getTrProps}
							/>
							<h2>Approved Master Plans</h2>
							<FullTable
								data={this.buildApprovedTable()}
								columns={this.state.approvedColumns}
								name="arc__pending__master"
								title="ARC Pending Master"
								getTrProps={this.getTrProps}
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		currentDates: state.currentDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ARC)
